import { API_PATHS } from "../constants/api-paths";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { IResponse, request } from "../core/api.client";

export interface ISkuByCardApiResponse {
  subCategory: string;
  productSkuLabel: string;
  displayAmountPrefix1: string;
  subCategorySequence: number;
  displayAmountPrefix2: string;
  type: string;
  offerType: string;
  cta: {
    appLink: string;
    webLink: string;
    label: string;
  };
  displayAmountSuffix: string;
  ccRewardsOnSpends: string;
  skuId: string;
  subOfferType: string;
  nudge1: string;
  nudge2: string;
  usp1Text: string;
  subClpSectionName: string;
  cardCode: string;
  actualAmount: number;
  categorySequence: number;
  ccBenefit: string;
  usp2Text: string;
  displayAmount: string;
  productCode: string;
  category: string;
  skuImage: string;
  ccBank: string;
}

export const getSKUByCard = async (cardCode: string): Promise<IResponse<ISkuByCardApiResponse>> => {
  try {
    const response = await createCacheAsync(
      `${API_PATHS.skuByCard}-${cardCode}`,
      request<ISkuByCardApiResponse>,
      {
        method: "GET",
        url: `${API_PATHS.skuByCard}/${cardCode}`,
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
